import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "time-edit-view" }
const _hoisted_2 = { class: "row v-center center gap" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "gg-close" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "fill row center h2" }, "Cancel booking", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1)
const _hoisted_7 = { class: "row col item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "pad-bottom" }, "You are cancelling:", -1)
const _hoisted_9 = { class: "item-box col" }
const _hoisted_10 = { class: "activity-title" }
const _hoisted_11 = {
  key: 0,
  class: "bold"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1)
const _hoisted_15 = { class: "row v-center spaced" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "gg-chevron-left" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notify_box = _resolveComponent("notify-box")!
  const _component_progress_button = _resolveComponent("progress-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "close-button link",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'OrderTime' })))
      }, _hoisted_4),
      _hoisted_5
    ]),
    _hoisted_6,
    (_ctx.error)
      ? (_openBlock(), _createBlock(_component_notify_box, {
          key: 0,
          type: "error"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.error), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.package?.Name), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.package?.Activities, (activity) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "activity-time",
            key: activity.OrderEntityKey ?? 0
          }, [
            (_ctx.package?.PackageKey)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(activity.Name), 1))
              : _createCommentVNode("", true),
            (activity.AppointmentTypeKey != 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activity.SelectedTimes, (time) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: time.DisplayName
                    }, [
                      _createTextVNode(_toDisplayString(time.AppointmentDate) + " ", 1),
                      (time.AppointmentTypeKey == 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, " @ " + _toDisplayString(time.DisplayName), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _hoisted_14,
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("button", {
        class: "row v-center gray",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1)))
      }, [
        _hoisted_16,
        _createTextVNode(" Back")
      ]),
      _createVNode(_component_progress_button, {
        showLoader: _ctx.loading,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onAction()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Cancel my booking")
        ]),
        _: 1
      }, 8, ["showLoader"])
    ])
  ]))
}